<template>
    <div id="HistoryDataChart">
        <div class="data_head" id="serchForm">
            <div style="display: flex;align-items: center;flex-wrap: wrap">
                <div class="head_content">
                    <div class="text_panel">测点</div>
                    <el-cascader
                        ref="spot"
                        v-model="measureNos"
                        :options="paramOptions"
                        :props="{
              value: 'code',
              label: 'name',
              children: 'childHashSet',
              emitPath: false,
              multiple: true,
            }"
                        :show-all-levels="false"
                        clearable
                        collapse-tags
                        :disabled="holeNumber.length !== 0"
                    ></el-cascader>
                </div>
                <!--        @visible-change="judgeSpot"-->
                
                <!--        <div  class="head_content" v-if="holeOptions.length!==0">-->
                <!--          <div class="text_panel">测孔</div>-->
                <!--          <el-cascader-->
                <!--            ref="hole"-->
                <!--            v-model="holeNumber"-->
                <!--            :options="holeOptions"-->
                <!--            :props="{ value: 'code', label: 'name', children: 'childHashSet' }"-->
                <!--            :show-all-levels="false"-->
                <!--            clearable-->
                <!--            collapse-tags-->
                <!--            :disabled="measureNos.length !== 0"-->
                <!--            @change="judgeHole"-->
                <!--          ></el-cascader>-->
                <!--        </div>-->
                <div style="margin-left: 20px">
                    <el-date-picker
                        v-model="dates"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        value-format="yyyy-MM-dd"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </div>
                <div>
                    <el-button
                        type="primary"
                        @click.native="search()"
                        :loading="loading1"
                        class="searchButton"
                    >
                        查 询
                    </el-button>
                </div>
                <div>
                    <el-button
                        type="primary"
                        @click.native="downLoad('historyData_chart')"
                        class="searchButton"
                    >
                        图片下载
                    </el-button>
                </div>
                <div>
                    <el-button
                        type="primary"
                        @click="exportExcel()"
                        class="searchButton"
                        :loading="loading2"
                    >
                        导出数据
                    </el-button>
                </div>
                <div style="margin-left: 20px" v-if="isShowPredictCrack()">
                    <el-select class="el-cascader" v-model="selectPredictRange" placeholder="请选择预测范围">
                        <el-option
                            label="24小时"
                            value="24小时">
                        </el-option>
                        <el-option
                            label="7天"
                            value="7天">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="isShowPredictCrack()">
                    <el-button
                        type="primary"
                        class="searchButton"
                        :loading="loading3"
                        @click="predictCrack()"
                    >
                        预测
                    </el-button>
                </div>
            </div>
        </div>
        
        <div class="tableContent">
            <div
                v-loading="loading1 || loading2 || loading3"
                element-loading-background="rgba(0, 0, 0, 0.7)"
                element-loading-text="数据正在加载，请稍等"
                element-loading-spinner="el-icon-loading"
            >
                <div id="historyData_chart" class="chart"></div>
            </div>
        </div>
        
        <el-dialog
            title="模型选点"
            :visible.sync="dialogVisible"
            width="65%"
            center
            :modal-append-to-body="false"
        >
            <div id="modelDraw" class="drawCanvas"></div>
        </el-dialog>
    </div>
</template>

<script>
import echarts from "echarts";
import measures from "../project/measures";
// 声明Viewer及其它
let viewer3D = null;
let app = null;

export default {
    name: "HistoryDataChart",
    data() {
        return {
            measureNos: [],
            dates: [],
            paramOptions: [],
            loading1: false,
            loading2: false,
            loading3: false,
            /*模型选点*/
            dialogVisible: false, //模型模态框
            loadComplete: false, //bim模型加载完成
            viewer3D: null, //模型构建
            systemType: "0", //系统类型,
            // sureVisible:false,
            // surePointNum:'',
            measures: [], //测点信息数组
            allPoint: [], //所有测点位置
            holeOptions: [], //所有孔集合
            holeNumber: [], //选中测孔
            holeEchartData: "", //查询测孔名字
            codeData: "",
            downLoadShow: false,
            selectPredictRange: "24小时"
        };
    },
    mounted: function() {
        this.projectMenus();
        this.getHoleDataList();
        this.getsetting();
        this.path = localStorage.getItem("path");
        this.systemType = localStorage.getItem("systemType");
    },
    methods: {
        generateRandomTemp(min, max) {
            // 白天温度范围
            const daytimeTempRange = [(min + max) / 2, max];  // 假设白天温度在 8 到 10 度之间
            
            // 晚上温度范围
            const nighttimeTempRange = [min, (min + max) / 2];  // 假设晚上温度在 6 到 8 度之间
            
            // 模拟一天中每小时的温度变化
            const hourlyTemperatures = [];
            for (let hour = 0; hour < 24; hour++) {
                let temperature;
                if (hour < 8 || hour > 18) {  // 假设晚上从 0 点到早上 7 点，以及傍晚 6 点到 24 点
                    temperature = getRandomInt(nighttimeTempRange[0], nighttimeTempRange[1]);
                } else {  // 白天其余时间
                    temperature = getRandomInt(daytimeTempRange[0], daytimeTempRange[1]);
                }
                hourlyTemperatures.push(temperature);
            }
            
            return hourlyTemperatures
            
            function getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        },
        predictCrack() {
            let myChart = echarts.getInstanceByDom(document.getElementById("historyData_chart"));
            this.loading3 = true
            let arr = []
            this.dates.forEach(data => {
                arr.push(new Date(data).format("yyyyMM"))
            })
            // arr去重
            arr = Array.from(new Set(arr))
            let getHistoryWeatherObj = {
                childProjectId: localStorage.getItem("mainId"),
                month: arr.join(","),
                startTime: new Date(this.dates[0]).format("yyyy-MM-dd"),
                endTime: new Date(this.dates[1]).format("yyyy-MM-dd")
            }
            
            this.$axios.post("/api/monitor/weather/getHistoryWeather", getHistoryWeatherObj).then(res => {
                let values = []
                if (res.data.datas && res.data.status == 200) {
                    if (res.data.datas.values) {
                        values = res.data.datas.values
                        let allTempArr = []
                        values.forEach(data => {
                            data.hourlyTemperatures = this.generateRandomTemp(Number(data.min_temperature), Number(data.max_temperature))
                            allTempArr = allTempArr.concat(data.hourlyTemperatures)
                        })
                        
                        if (myChart) {
                            if (myChart.getOption().series) {
                                let series = myChart.getOption().series
                                let allDataArr = []
                                series.forEach(data1 => {
                                    
                                    let obj = {
                                        name: data1.name,
                                        sameArr: [],
                                        averageArr: []
                                    }
                                    let sameObj = {
                                        time: data1.data[0][0].substring(0, 13),
                                        arr: []
                                    }
                                    obj.sameArr.push(sameObj)
                                    data1.data.forEach(data2 => {
                                        if (data2[0].indexOf(obj.sameArr[obj.sameArr.length - 1].time) != -1) {
                                            obj.sameArr[obj.sameArr.length - 1].arr.push(data2)
                                        } else {
                                            sameObj = {
                                                time: data2[0].substring(0, 13),
                                                arr: []
                                            }
                                            obj.sameArr.push(sameObj)
                                            obj.sameArr[obj.sameArr.length - 1].arr.push(data2)
                                        }
                                    })
                                    obj.sameArr.forEach(data3 => {
                                        let sum = 0
                                        let length = data3.arr.length
                                        data3.arr.forEach(data4 => {
                                            if (!isNaN(Number(data4[1]))) {
                                                sum += Number(data4[1])
                                            } else {
                                                length = length - 1
                                            }
                                        })
                                        let average = sum / length
                                        obj.averageArr.push(Number(average.toFixed(4)))
                                    })
                                    allDataArr.push(obj)
                                })
                                
                                let isContinue = true
                                let getAreaHourWeatherObj = {}
                                
                                for (let i = 0; i < allDataArr.length; i++) {
                                    if (allDataArr[i].averageArr.length < 24) {
                                        isContinue = false
                                        break
                                    } else {
                                        getAreaHourWeatherObj = {
                                            childProjectId: localStorage.getItem("mainId"),
                                            cracks: allDataArr[i].averageArr.slice(allDataArr[i].averageArr.length - 24, allDataArr[i].averageArr.length),
                                            temperatures: allTempArr.slice(allTempArr.length - 24, allTempArr.length)
                                        }
                                    }
                                }
                                
                                if (isContinue == false) {
                                    this.$message.error("预测数据不足24条，请增加查询日期范围")
                                    this.loading3 = false
                                    return
                                }
                                
                                this.$axios.post("/api/monitor/weather/getAreaHourWeather", getAreaHourWeatherObj).then(res => {
                                    this.loading3 = false
                                    if (res.data.datas && res.data.status == 200) {
                                        if (res.data.datas.values) {
                                            values = res.data.datas.values
                                            if (myChart) {
                                                if (myChart.getOption().series) {
                                                    let series = myChart.getOption().series
                                                    let newSerie = {}
                                                    series.forEach(data1 => {
                                                        newSerie = JSON.parse(JSON.stringify(data1))
                                                        let data = data1.data
                                                        
                                                        let lastTime = data[data.length - 1][0]
                                                        let time = new Date(lastTime).getTime()
                                                        newSerie.data = []
                                                        values.forEach((data2, index2) => {
                                                            let newTime = time + 1000 * 60 * 60 * (index2)
                                                            newSerie.data.push([new Date(newTime).format("yyyy-MM-dd hh:mm:ss"), (Number(data2)).toFixed(4)])
                                                        })
                                                    })
                                                    newSerie.lineStyle = {
                                                        "width": 2,
                                                        "type": "solid",
                                                        "color": "#e68f02"
                                                    }
                                                    newSerie.makePoint = {
                                                        "data": [
                                                            {
                                                                "type": "max"
                                                            }
                                                        ]
                                                    }
                                                    series.push(newSerie)
                                                    myChart.setOption({
                                                        series: series
                                                    })
                                                }
                                            }
                                        }
                                    } else {
                                        this.$message.error(res.data.message)
                                    }
                                }).catch(err => {
                                    console.log(err)
                                    this.$message.error("预测失败")
                                    this.loading3 = false
                                })
                            }
                        } else {
                            this.$message.error("请先点击查询")
                        }
                    }
                } else {
                    this.loading3 = false
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                console.log(err)
                this.$message.error("预测失败")
                this.loading3 = false
            })
        },
        isShowPredictCrack() {
            let show = true
            if (this.measureNos.length == 0) {
                show = false
            }
            for (let i = 0; i < this.measureNos.length; i++) {
                if (this.measureNos[i].substring(0, 4) != "0208") {
                    show = false
                    break
                }
            }
            return show
        },
        bimfaceSuccess(viewMetaData) {
            let appConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
            appConfig.domElement = document.getElementById("modelDraw");
            appConfig.Toolbars = []; // 取消工具条
            appConfig.Buttons = [];
            let app = new Glodon.Bimface.Application.WebApplication3D(appConfig);
            this.viewer3D = app.getViewer();
            // this.viewer3D.enableMouseHoverHighlight();
            this.viewer3D.hideViewHouse();
            this.viewer3D.addEventListener(
                Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked,
                this.mouseClick
            );
            this.viewer3D.addEventListener(
                Glodon.Bimface.Viewer.Viewer3DEvent.MouseDoubleClicked,
                this.objectClick
            );
            this.viewer3D.addEventListener(
                Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded,
                () => {
                    this.loadComplete = true;
                    let color = new Glodon.Web.Graphics.Color("#23ff56", 1);
                    this.viewer3D.overrideComponentsColorById(this.allPoint, color);
                    this.viewer3D.render();
                }
            );
            app.addView(viewMetaData.viewToken);
        },
        /*点击*/
        mouseClick(data) {
            if (
                confirm("是否选择测点：" + data.objectId + "？", "", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    center: true,
                    showClose: false,
                })
            ) {
                this.$axios
                    .get(
                        "/api/monitor/dataHistory/getMeasureNoByObjectId?ObjectId=" +
                        data.objectId
                    )
                    .then((res) => {
                        if (res.data.status === 200) {
                            this.measureNos = res.data.datas.values;
                            this.dialogVisible = false;
                        } else {
                            this.$message({ message: res.data.message, type: "error" });
                        }
                    });
                // this.dialogVisible=false
            }
        },
        /*双击*/
        objectClick(data) {
            if (
                confirm("是否选择测点：" + data.objectId + "？", "", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    center: true,
                    showClose: false,
                })
            ) {
                this.$axios
                    .get(
                        "/api/monitor/dataHistory/getMeasureNoByObjectId?ObjectId=" +
                        data.objectId
                    )
                    .then((res) => {
                        if (res.data.status === 200) {
                            this.measureNos = res.data.datas.values;
                            this.dialogVisible = false;
                        } else {
                            this.$message({ message: res.data.message, type: "error" });
                        }
                    });
                // this.dialogVisible=false
            }
        },
        getDramData() {
            this.$axios
                .get("/api/monitor/realTimeMonitor/getMeasuresByCode?code=all")
                .then((res) => {
                    if (res.data.status == 200) {
                        let that = this;
                        res.data.datas.values.forEach((item) => {
                            that.allPoint.push(item.modelObjectId);
                        });
                    }
                });
        },
        //获取测点集合
        projectMenus() {
            this.$axios
                .get("/api/monitor/dataHistory/getMeasureByCode")
                .then((res) => {
                    this.paramOptions = res.data.datas.values;
                    // this.paramOptions.forEach((item, index) => {
                    //     if (item.code === "0203" || item.code === "0103") {
                    //         this.paramOptions.splice(index, 1);
                    //     }
                    // });
                });
        },
        //获取测孔集合
        getHoleDataList() {
            this.holeOptions = []
            this.$axios.get("/api/monitor/dataHistory/getEmptyList").then((res) => {
                // res.data.datas.values.
                this.holeOptions.push(res.data.datas.values);
                //   res.data.datas.values.childHashSet.forEach((item,index)=>{
                //     if (item.name=='孔4'){
                //         res.data.datas.values.childHashSet.splice(index,1)
                //         this.holeOptions.push(res.data.datas.values)
                //     }
                // })
            });
        },
        /*获取配置时间*/
        getsetting() {
            this.dates = [];
            this.$axios.get("/api/monitor/dataHistory/getQuerySet").then((res) => {
                if (res.data.status == 200) {
                    if (res.data.datas.values.measureNos) {
                        this.measureNos = res.data.datas.values.measureNos.split(",")
                        // this.measureNos = [];
                        this.dates = []
                        // this.dates.push(res.data.datas.values.startTime, res.data.datas.values.endTime)
                        let date = new Date();
                        this.dates.push(
                            date.getFullYear() +
                            "-" +
                            (date.getMonth() + 1) +
                            "-" +
                            (date.getDate() - 1) +
                            " " +
                            "00:00:00"
                        );
                        this.dates.push(
                            date.getFullYear() +
                            "-" +
                            (date.getMonth() + 1) +
                            "-" +
                            date.getDate() +
                            " " +
                            "23:59:59"
                        );
                    } else {
                        let date = new Date();
                        this.dates.push(
                            date.getFullYear() +
                            "-" +
                            (date.getMonth() + 1) +
                            "-" +
                            (date.getDate() - 1) +
                            " " +
                            "00:00:00"
                        );
                        this.dates.push(
                            date.getFullYear() +
                            "-" +
                            (date.getMonth() + 1) +
                            "-" +
                            date.getDate() +
                            " " +
                            "00:00:00"
                        );
                    }
                }
            });
        },
        choseItem() {
            if (this.viewer3D) {
                this.dialogVisible = true;
            } else {
                if (this.dates !== null || this.dates.length !== 0) {
                    this.dialogVisible = true;
                    if (this.systemType === "1") {
                        this.getDramData();
                        let bimfaceOption = new BimfaceSDKLoaderConfig();
                        bimfaceOption.viewToken = this.path;
                        BimfaceSDKLoader.load(
                            bimfaceOption,
                            this.bimfaceSuccess,
                            this.bimfaceFail
                        );
                    }
                } else {
                    this.$message({
                        message: "时间区间未选择",
                        type: "warning",
                    });
                }
            }
        },
        //判断测点与测控只能查询一个条件
        judgeSpot(e) {
            if (!e && this.measureNos.length !== 0) {
                this.$message({
                    message: "已有测点，测孔将不能选择",
                    type: "warning",
                });
            }
        },
        judgeHole(val) {
            if ((this.holeNumber = val[1])) {
                this.holeNumber = val[1];
            } else {
                this.holeNumber = [];
            }
            if (this.holeNumber.length !== 0) {
                this.$message({
                    message: "已有测孔，测点将不能选择",
                    type: "warning",
                });
            }
        },
        search() {
            if (this.dates == null) {
                this.$message({
                    message: "时间区间未选择",
                    type: "warning",
                });
                return;
            }
            if (this.measureNos.length === 0 && this.holeNumber.length === 0) {
                this.$message({
                    message: "测点至少选择一个",
                    type: "warning",
                });
                return;
            }
            if (this.measureNos.length !== 0) {
                this.loading1 = true;
                let measureType = [];
                for (let i = 0; i < this.measureNos.length; i++) {
                    let measureNo = this.measureNos[i];
                    if (measureType[0] == null) {
                        measureType[0] = measureNo.substr(0, 6);
                    } else if (measureNo.indexOf(measureType[0]) == -1) {
                        if (measureType[1] == null) {
                            measureType[1] = measureNo.substr(0, 6);
                        } else if (measureNo.indexOf(measureType[1]) == -1) {
                            this.$message({
                                message: "不同类型参数只能选择2种查询",
                                type: "error",
                            });
                            this.loading1 = false;
                            return;
                        }
                    }
                }
                
                // this.downLoadShow=true
                // 测点信息
                this.$axios
                    .get(
                        `/api/monitor/dataHistory/getHistoryDataCurve?startTime=${
                            this.dates[0] + " " + "00:00:00"
                        }&endTime=${ this.dates[1] + " " + "23:59:59" }&measureNos=${
                            this.measureNos
                        }`
                    )
                    .then((res) => {
                        this.loading1 = false;
                        if (res.data.status === 200) {
                            let series = [];
                            res.data.datas.values.forEach((item) => {
                                if (!item.dataList || item.dataList.length == 0) {
                                    return
                                }
                                //三个值 XYZ
                                if (item.dataList[0].dataJson.substring(1, item.dataList[0].dataJson.length - 1).split(",").length > 2) {
                                    const newArr1 = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[0]
                                        );
                                        return data;
                                    });
                                    const newArr2 = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[1]
                                        );
                                        return data;
                                    });
                                    const newArr3 = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[2]
                                        );
                                        return data;
                                    });
                                    series.push(
                                        {
                                            data: newArr1,
                                            symbol: "none",
                                            name: "x:" + item.measureNo,
                                            type: "line",
                                            markPoint: {
                                                data: [{ type: "max" }],
                                            },
                                        },
                                        {
                                            data: newArr2,
                                            symbol: "none",
                                            name: "y:" + item.measureNo,
                                            type: "line",
                                            markPoint: {
                                                data: [{ type: "max" }],
                                            },
                                        },
                                        {
                                            data: newArr3,
                                            symbol: "none",
                                            name: "z:" + item.measureNo,
                                            type: "line",
                                            markPoint: {
                                                data: [{ type: "max" }],
                                            },
                                        }
                                    );
                                }
                                //两个值 XY
                                else if (item.dataList[0].dataJson.substring(1, item.dataList[0].dataJson.length - 1).split(",").length > 1
                                    && item.dataList[0].dataJson.substring(1, item.dataList[0].dataJson.length - 1).split(",").length < 3
                                ) {
                                    const newArr1 = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[0]
                                        );
                                        return data;
                                    });
                                    const newArr2 = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[1]
                                        );
                                        return data;
                                    });
                                    series.push(
                                        {
                                            data: newArr1,
                                            symbol: "none",
                                            name: "x:" + item.measureNo,
                                            type: "line",
                                            markPoint: {
                                                data: [{ type: "max" }],
                                            },
                                        },
                                        {
                                            data: newArr2,
                                            symbol: "none",
                                            name: "y:" + item.measureNo,
                                            type: "line",
                                            markPoint: {
                                                data: [{ type: "max" }],
                                            },
                                        },
                                    );
                                } else {
                                    const newArr = item.dataList.map((el) => {
                                        let data = [];
                                        data.push(
                                            el.dataTime,
                                            el.dataJson
                                                .substring(1, el.dataJson.length - 1)
                                                .split(",")[0]
                                        );
                                        return data;
                                    });
                                    series.push({
                                        data: newArr,
                                        name: item.measureNo,
                                        type: "line",
                                        symbol: "none",  //取消折点圆圈
                                        markPoint: {
                                            data: [{ type: "max" }],
                                        },
                                    });
                                }
                            });
                            let options = {
                                color: ["#CE5F61", "#6ED2B2", "#FE9804", "#A46F8A", "#F0B0B1"],
                                xAxis: [
                                    {
                                        type: "time",
                                        nameTextStyle: {
                                            borderColor: "#516B88",
                                        },
                                        axisLine: {
                                            lineStyle: {
                                                color: "#516B88",
                                            },
                                        },
                                        splitLine: {
                                            show: true,
                                            lineStyle: {
                                                color: ["#516B88"],
                                                width: 1,
                                                type: "solid",
                                            },
                                        },
                                    },
                                ],
                                tooltip: {
                                    show: true,
                                    trigger: "axis",
                                    //     formatter(params) {
                                    //      let str = ''
                                    //      params.forEach((item) => {
                                    //      str += '<span style="display:inline-block;margin-right:5px;border-radius:50%;' +
                                    //         'width:10px;height:10px;left:5px;background-color:' + item.color + '">' +
                                    //         '</span>'+ item.data[0] + "/"+ item.seriesName + ""  + " : " + item.data[1] + "<br />";
                                    //    });
                                    //    return str
                                    //   }
                                },
                                series: series,
                                yAxis: {
                                    type: "value",
                                    nameTextStyle: {
                                        fontWeight: "normal",
                                        fontSize: 12,
                                        color: "#516B88",
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#516B88",
                                        },
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            color: ["#516B88"],
                                            width: 1,
                                            type: "solid",
                                        },
                                    },
                                },
                                toolbox: {
                                    left: "right",
                                    feature: {
                                        saveAsImage: {
                                            iconStyle: {
                                                borderColor: "red",
                                            },
                                            backgroundColor: "#0B3A68",
                                        },
                                    },
                                },
                                dataZoom: {
                                    show: true,
                                    start: 70,
                                },
                                grid: {
                                    top: "10%",
                                    left: "5%",
                                    right: "4%",
                                    bottom: "10%",
                                    containLabel: true,
                                },
                                legend: {
                                    top: 10,
                                    left: "center",
                                    textStyle: {
                                        color: "#A7CCF6",
                                    },
                                },
                            };
                            let myChart = echarts.init(
                                document.getElementById("historyData_chart")
                            );
                            myChart.setOption(options, true);
                        }
                        // series里面拼接数据
                        
                    });
            }
            if (this.holeNumber.length !== 0) {
                this.loading1 = true;
                this.codeData = this.holeNumber;
                this.$axios
                    .get(
                        `/api/push-center/huace/data/getEmptyData?startTime=${
                            this.dates[0] + " " + "00:00:00"
                        }&endTime=${ this.dates[1] + " " + "23:59:59" }&code=${ this.codeData }`
                    )
                    .then((res) => {
                        this.loading1 = false;
                        if (res.data.status === 200) {
                            this.holeEchartData = res.data.datas.values;
                            this.openBigEcharts();
                        }
                    });
            }
        },
        // Ecahrt下载
        downLoad(chartId) {
            // if(this.holeNumber.length==0){
            //     this.$message({
            //         type:'error',
            //         message:'请先查询后下载'
            //     })
            //     return
            // }
            var myChart = echarts.getInstanceByDom(document.getElementById(chartId));
            var url = myChart.getConnectedDataURL({
                pixelRatio: 5, //导出的图片分辨率比率,默认是1
                backgroundColor: "#0B3A68", //图表背景色
                excludeComponents: [
                    //保存图表时忽略的工具组件,默认忽略工具栏
                    "toolbox",
                ],
                type: "png", //图片类型支持png和jpeg
            });
            var $a = document.createElement("a");
            var type = "png";
            $a.download = this.dates + "图片" + "." + type;
            $a.target = "_blank";
            $a.href = url;
            // Chrome and Firefox
            if (typeof MouseEvent === "function") {
                var evt = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                });
                $a.dispatchEvent(evt);
            }
            // IE
            else {
                var html = "";
                ("<body style=\"margin:0;\">");
                "![](" + url + ")";
                ("</body>");
                var tab = window.open();
                tab.document.write(html);
            }
        },
        // 测孔信息
        openBigEcharts() {
            let myChart;
            myChart = echarts.init(document.getElementById("historyData_chart"));
            let option = {
                grid: {
                    top: "10%",
                    left: "8%",
                    right: "8%",
                    bottom: "10%",
                },
                legend: {
                    textStyle: {
                        color: "#ffffff", //字体颜色
                    },
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            iconStyle: {
                                borderColor: "red",
                            },
                            backgroundColor: "#0B3A68",
                        },
                    },
                },
                tooltip: {
                    trigger: "axis",
                    formatter(params) {
                        let str = "";
                        params.forEach((item) => {
                            str +=
                                "<span style=\"display:inline-block;margin-right:5px;border-radius:50%;" +
                                "width:10px;height:10px;left:5px;background-color:" +
                                item.color +
                                "\">" +
                                "</span>" +
                                item.seriesName +
                                ":" +
                                item.data[2] +
                                "<br />" +
                                item.data[0] +
                                "<br />";
                        });
                        return str;
                    },
                },
                xAxis: {
                    type: "value",
                    show: true,
                    boundaryGap: false,
                    axisLabel: {
                        color: "#FFF",
                    },
                },
                color: ["#FB4D4B", "#409EFF", "#3CB371"],
                yAxis: {
                    type: "value",
                    boundaryGap: false,
                    show: true,
                    data: [],
                    axisLabel: {
                        formatter: "{value} m",
                        color: function() {
                            return "#FFF";
                        },
                    },
                },
                series: [],
            };
            let hightValue = this.holeEchartData.highValue
            let expectNum = ""
            if (hightValue % 2 === 0) {
                expectNum = hightValue / 2 + 1
            } else {
                expectNum = Math.ceil(hightValue / 2)
            }
            for (let key in this.holeEchartData.timesMap) {
                
                let dataValue = []
                let realHight = ""
                let exist = ""
                exist = expectNum - this.holeEchartData.timesMap[key].length
                for (let i = 0; i < this.holeEchartData.timesMap[key].length; i++) {
                    let dataStr = this.holeEchartData.timesMap[key][i];
                    let data = dataStr.dataJson.substring(1).replace("]", "");
                    realHight = i * -2
                    dataValue.push([parseFloat(data).toFixed(2), i * -2, dataStr.measureNo]);
                }
                // 测试转换格式
                if (exist > 0) {
                    for (let j = 1; j < exist + 1; j++) {
                        dataValue.push(["0.00", realHight + j * -2, "0"]);
                    }
                }
                option.series.push({
                    type: "line",
                    name: key,
                    symbol: "none",  //取消折点圆圈
                    data: dataValue,
                });
            }
            myChart.setOption(option, true);
        },
        exportExcel() {
            if (this.dates == null) {
                this.$message({
                    message: "时间区间未选择",
                    type: "warning"
                });
                return;
            }
            if (this.measureNos.length == 0) {
                this.$message({
                    message: "至少选择一个测点",
                    type: "warning"
                });
                return;
            }
            if (this.measureNos.length !== 0) {
                this.loading2 = true;
                let measureType = [];
                for (let i = 0; i < this.measureNos.length; i++) {
                    let measureNo = this.measureNos[i];
                    if (measureType[0] == null) {
                        measureType[0] = measureNo.substr(0, 6);
                    } else if (measureNo.indexOf(measureType[0]) == -1) {
                        if (measureType[1] == null) {
                            measureType[1] = measureNo.substr(0, 6);
                        } else if (measureNo.indexOf(measureType[1]) == -1) {
                            this.$message({
                                message: "不同类型参数只能选择2种查询",
                                type: "error"
                            });
                            this.loading2 = false;
                            return;
                        }
                    }
                }
                // 测点信息
                this.$axios.get(
                    `/api/monitor/dataHistory/getHistoryDataExport?startTime=${
                        this.dates[0] + " " + "00:00:00"
                    }&endTime=${ this.dates[1] + " " + "23:59:59" }&measureNos=${
                        this.measureNos
                    }`, {
                        responseType: "blob"
                    }).then((res) => {
                    this.loading2 = false;
                    if (res.status === 200) {
                        let filename = "历史数据.xlsx";
                        //创建a标签
                        let linkElement = document.createElement("a");
                        //创建 blob对象 第一个参数 res.data是代表后端返回的文件流  ，第二个参数设置文件类型
                        let blob = new Blob([res.data], {
                            type: res.headers["content-type"]
                        });
                        //生成生成下载链接  这个链接放在a标签上是直接下载，放在img上可以直接显示图片问价，视频同理
                        let url = window.URL.createObjectURL(blob);
                        
                        linkElement.setAttribute("href", url);
                        linkElement.setAttribute("target", "_blank");
                        linkElement.setAttribute("download", filename);
                        //模拟点击a标签
                        if (typeof MouseEvent == "function") {
                            let event = new MouseEvent("click", {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            linkElement.dispatchEvent(event);
                        }
                    }
                });
            }
        },
    },
};
</script>

<style>
#HistoryDataChart .el-cascader .el-input .el-input__inner {
    color: #fff;
    /*height: 38px !important;*/
    background-color: #3457de;
}

#HistoryDataChart .input-item-text, input[type=text], input[type=date], select {
    height: 40px !important;
}


#HistoryDataChart .el-date-editor--daterange.el-input__inner {
    background-color: #3457de;
    color: #fff;
}

#HistoryDataChart .el-date-editor .el-date-editor {
    /*margin-top:40px !important;*/
    height: 38px !important;
}

#HistoryDataChart .el-date-editor .el-range-input {
    background-color: #3457de;
    height: 100% !important;
    color: #fff;
}

#HistoryDataChart .el-date-editor .el-range-separator {
    background-color: unset;
    color: #fff;
}
</style>

<style scoped>
@import url('../../assets/css/style.css');

.head_content {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
}

.text_panel {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    width: 4rem;
    font-weight: bold;
    color: #fff;
}

.chart {
    height: 500px;
    width: 100%;
    overflow: hidden;
}

.searchButton {
    margin-left: 30px;
    background-color: #e68f02;
    border: #e68f02;
    color: #fff;
}

/*模态框*/
/deep/ .el-dialog {
    background: linear-gradient(
        -90deg,
        rgb(60, 32, 242) 0%,
        rgb(52, 87, 222) 100%
    );
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
}

/deep/ .el-dialog__body {
    padding: 4px 0;
}

/deep/ .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: rgb(218, 217, 254);
    font-weight: bold;
    white-space: normal;
    word-break: normal;
}

/deep/ .el-dialog__headerbtn {
    background-color: #001334;
    padding: 5px 5px;
}

.drawCanvas {
    height: 400px;
    width: 99%;
    margin: 0 0.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/dataManage/history-data-chart.vue